import React from 'react';
import Agents from 'containers/Organizations/SingleOrganization/Agents/List';

export default {
  name: 'agents',
  path: /.*\/organizations\/\d+\/agents$/,
  component: <Agents />,
};
